export const currentPage = state => state.page.selected



// WEBPACK FOOTER //
// ./redux/selectors/page.jsx